class xloadingbar{
	/**
	 * 
	 * @param {string} type loaderio tipas (not required)
	 * @param {number} maxVal failo dydis
	 * @param {any} appendTo prie kurio elemento prikabinamas loaderis (default = 'body')
	 */
    start(type, maxVal, appendTo){
		this.container = appendTo?appendTo:'body';
		$(this.container).find('.xprogress-backdrop').remove();
		/** TEMPLATES */

		this.backdrop = $(`
			<div class="xprogress-backdrop ${type}">
				<div class="xprogress-container">
				</div>
			</div>
		`);
		//defaultinis spinneris
		this.spinner = `<div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`;

		//progress bar
		this.progress = $(`<div class="xloadingbar">
							<div class="xloadingbar-progress"></div>
						</div>`);

		/** TEMPLATES END */
		
		if (type && type !== 'loadingbar') {
			this.getSvg(type);
		} else {
			this.bar = this.spinner;
		}

		$(this.container).addClass('xblur').append(this.backdrop);

		if (type !=='loadingbar'){
			this.appendSpinner();
		}
		if (maxVal){
			this.maxVal = maxVal;
			this.appendProgress();
		}
	}

	stop(){
		$(this.backdrop).remove();
		$(this.container).removeClass('xblur');
	}
	/**
	 * 
	 * @param {string} type loaderio tipas ir svg failo pavadinimas
	 */
	getSvg(type){
		let svg = new XMLHttpRequest();
			svg.open("GET", `/static/assets/components/loadingbar/${type}.svg`, false);
			svg.overrideMimeType("image/svg+xml");
			svg.send("");
		
		try {
			this[type] = svg.responseXML.documentElement;
		} catch (except) {
			if(except instanceof TypeError){
				this.bar = this.spinner;
				return;
			} else {
				throw except;
			}
		}

		this.bar = this[type];
	}

	appendSpinner(){
		this.backdrop.find('.xprogress-container').append(this.bar);
	}

	appendProgress(){
		this.backdrop.find('.xprogress-container').append(this.progress);
	}
	/**
	 * 
	 * @param {int} val uploadinamu duomenu dabartinis dydis
	 */
	updateProgress(val){
		let indicator = this.progress.find('.xloadingbar-progress'),
			percent = (val * 100) / this.maxVal;

		if (val < this.maxVal) {
			indicator.css('width', `${percent}%`);
		} else {
			indicator.css('width', '100%');
		}

	}

}

var loader = new xloadingbar;